import { useQuery } from "react-query";
import { QUERY_KEYS } from "../constants/reactQueryKeyConsts";
import axios from "axios";

export const useGetDashboardData = ({body, config}) => {
    //console.log("config is", config);
    return useQuery({
      queryKey: [QUERY_KEYS.DASHBOARD],
      queryFn: () => {
        return axios
          .get(`${process.env.REACT_APP_API_URI}DashboardGridbind?id=${body.msid}&role=${body.role}&name=${body.name}&email=${body.email}`, config)
          .then((res) => {
            
             if(res.data.error){
              throw new Error(res.data.message)
             }
             return res.data;
          });
      },
      refetchOnWindowFocus: false,
    });
  }

  export const useGetDashboardDataOfAuditor = ({body, config}) => {
    return useQuery({
      queryKey: [QUERY_KEYS.AUDITOR_DASHBOARD,body?.msid],
      queryFn: () => {
        return axios
          .get(`${process.env.REACT_APP_API_URI}DashboardGridbind?id=${body.msid}&role=${body.role}&name=${body.name}&email=${body.email}`, config)
          .then((res) =>  {
            if(res.data.error){
              throw new Error(res.data.message)
             }
             return res.data;
          });
      },
      enabled: body.msid != '' || (!!body.msid),
      refetchOnWindowFocus: false,
    });
  }